import qs from 'qs'
import history from 'common/utils/history'

export const stringify = (ob) => qs.stringify(ob, { encode: false })

export const getLocationPathname = () => window.location.pathname

export const getRouteSearchParams = () => qs.parse(window.location.search.slice(1))

export const pushNewUrlParameters = (newURL) => {
  history.push(`${getLocationPathname()}?${newURL}`)
}
